import { atom } from 'recoil';

export const authStore = atom({
  key: 'AUTH_STORE',
  default: null,
});
